import { render } from "./CreateUpdate.vue?vue&type=template&id=08fe372a"
import script from "./CreateUpdate.vue?vue&type=script&lang=js"
export * from "./CreateUpdate.vue?vue&type=script&lang=js"

import "./CreateUpdate.vue?vue&type=style&index=0&id=08fe372a&lang=css"

import exportComponent from "E:\\wamp64\\www\\law-firm-system-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__